import React from 'react'
import './Solvent.css'
import bucket from './image/BucketElevatorChain.jpg'
import drag from './image/Dragchain.jpg'
import extractor from './image/Extractorchain.jpg'

const Solvent = () => {
  return (
    <div>
      <div className="solventp">
        <p className="p">Solvent Plant</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Solvent Plant</p> */}
        </div>
      </div>

    <div className="solvent">
      <div className="unimg">
        <figure>
          <img src={bucket} alt="Bucket Elevator Chain"/>
          <figcaption>Bucket Elevator Chain</figcaption>
        </figure>
      </div>

      <div className="soimg">
        <figure>
          <img src={drag} alt="Drag Chain / Enmass Conveyor Chain"/>
          <figcaption>Drag Chain / Enmass Conveyor Chain</figcaption>
        </figure>
      </div>

      <div className="soimg">
        <figure>
          <img src={extractor} alt="Extractor Chain"/>
          <figcaption>Extractor Chain</figcaption>
        </figure>
      </div>
      </div>


    </div>
  )
}

export default Solvent
